<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="7" cy="7.5" r="6.5" :stroke="props.iconColor" />
	</svg>
</template>
<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 14,
		height: 15,
		iconColor: '#ffffff',
	}
);
</script>

<style lang="scss" scoped></style>
